export const parseDate = (date: string, isUnixtimestamp: boolean = false) => {
  return new Date(isUnixtimestamp ? parseInt(date) : Date.parse(date)).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};
